input[type].filterInput {
  margin-bottom: 0;
}

.dateRangeCell :global(.ui__dateRangePicker) {
  align-items: center;

  input[type='date'] {
    margin-bottom: 0;
    flex-shrink: 0;
  }

  > span {
    margin-bottom: 0 !important;
    flex-shrink: 0;
  }
}

.dateTimeRangeCell {
  align-items: center;

  input[type='datetime-local'] {
    margin-bottom: 0;
    flex-shrink: 0;
  }

  > span {
    margin-bottom: 0 !important;
    flex-shrink: 0;
  }
}
